import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Route, RouteProps } from 'react-router-dom';
import { useHistory } from 'react-router';
import { isAllow, getMenuItemId } from "./helpers/authorizationHelper";
import { BffApiResultHandler } from './BffApiResultHandler';
import { TermsOfService } from "./TermsOfService"
import { NowLoading } from "./NowLoading"
import { getLoginUserInfoAsync, storedLoginUserInfo } from "../../modules/core/authModule";
import { setCurrnetMenuItemId, isPrimeMenu, isPrimeMenuAuthRoute, } from "../../modules/core/menuModule";
import { initApiResult } from '../../modules/core/bffApiModule';
import { initDateString } from '../../modules/core/datePickerModule';
import { initDateString as initMonthString } from '../../modules/core/monthPickerModule';
import { initMessages } from '../../modules/core/commonMessageModule';
import * as CONSTANTS from '../../constants/constants';
import { SystemError } from './SystemError';


export const AuthRoute = (props: RouteProps) => {

  const dispatch = useDispatch();
  const history = useHistory();
  const loginUserInfo = useSelector(storedLoginUserInfo);
  const isPrime = useSelector(isPrimeMenu);
  const isPrimeAuth = useSelector(isPrimeMenuAuthRoute);

  let targetPath = props.path;

  // TOP-URLが指定された場合、遷移先URLをログインユーザー情報から決定します。
  if (CONSTANTS.PATH_TOP === props.path && "" !== loginUserInfo.mcdpId) {

    // PRIME契約サービス利用可能フラグが利用可能
    if ("1" === loginUserInfo.primeServiceAvailableFlg) {

      // 元請_権限設定済みフラグが未設定かつ管理者権限の場合
      if ("1" !== loginUserInfo.primeAuthSettingFinishedFlg
        && "1" === loginUserInfo.authorityInfo.primeSystemMngAuth) {
        // prime ユーザ権限管理 一覧
        targetPath = CONSTANTS.PATH_PRIME_AUTH_LIST;
      } else {
        // prime 勤怠実績報告 一覧
        targetPath = CONSTANTS.PATH_PRIME_ATTENDANCE_SUMMARY;
      }

    } else {
      // 協力_権限設定済みフラグが未設定かつ管理者権限の場合
      if ("1" !== loginUserInfo.partnerAuthSettingFinishedFlg
        && "1" === loginUserInfo.authorityInfo.partnerSystemMngAuth) {
        // partner ユーザ権限管理 一覧
        targetPath = CONSTANTS.PATH_PARTNER_AUTH_LIST;
      } else {
        // partner 勤怠実績報告 一覧
        if (window.innerWidth <= 850) {
          // 画面幅が850px以下の場合スマホ用の画面に遷移
          targetPath = CONSTANTS.PATH_PARTNER_ATTENDANCE_MOBILE_SUMMARY;
        } else {
          targetPath = CONSTANTS.PATH_PARTNER_ATTENDANCE_SUMMARY;
        }
      }
    }
  }

  // 指定されたパスから、メニューIDを取得します。
  const menuItemId = getMenuItemId(targetPath);
    if ("" !== menuItemId) {
      // 現在のメニューIDをステートに保存します。
      dispatch(setCurrnetMenuItemId(menuItemId));
    }


  useEffect(() => {
    // ログインユーザー情報が未取得の場合、取得APIを呼び出します。
    if ("" === loginUserInfo.mcdpId) {
      dispatch(getLoginUserInfoAsync());
    }
    if ("" !== menuItemId) {
      // 現在のメニューIDをステートに保存します。
      dispatch(setCurrnetMenuItemId(menuItemId));
    }
    // 共通メッセージ情報を初期化します。
    dispatch(initMessages());

  }, [loginUserInfo]);

  // ログインユーザー情報取得まではローディング画面を描画します。
  // API制御のためAPIApiResultHandlerコンポーネントを読み込みます。
  if ("" === loginUserInfo.mcdpId) {
    return (
      <>
        <BffApiResultHandler />
        <NowLoading />
      </>
    )
  }

  // ログイン直後と画面リロード時は、isPrimeAuthに値が入らないため、フラグを使用し判定する
  if (typeof isPrimeAuth === "undefined" ) {
    // 利用可能フラグが利用不可の場合（元請ではない場合）、403画面を描画します。
    if (loginUserInfo.contractPrimeService === CONSTANTS.CONTRACT_PRIME_SERVICE.CONTRACT && "0" === loginUserInfo.primeServiceAvailableFlg) {
      history.push(CONSTANTS.PATH_PRIME_PERMISSION_ERROR);
      return <></>;
    }

    // プライム契約をしていない場合はエラー画面遷移
    if (loginUserInfo.contractPrimeService !== CONSTANTS.CONTRACT_PRIME_SERVICE.CONTRACT && "1" === loginUserInfo.primeServiceAvailableFlg) {
      history.push(CONSTANTS.PATH_PRIME_NO_CONTRACT_ERROR);
      return <></>;
    }

    // 利用対象未設定の場合はエラー
    if (loginUserInfo.contractPrimeService !== CONSTANTS.CONTRACT_PRIME_SERVICE.CONTRACT && "0" === loginUserInfo.primeServiceAvailableFlg && "0" === loginUserInfo.partnerAvailableFlg) {
      history.push(CONSTANTS.PATH_PARTNER_NOT_SET_USER_ERROR);
      return <></>;
    }

    // 約款が未約の場合は約款同意画面を表示
    if (("1" === loginUserInfo.primeServiceAvailableFlg && "0" === loginUserInfo.primeServiceTermsAgreeFlg) ||
        ("1" === loginUserInfo.partnerAvailableFlg && "0" === loginUserInfo.partnerServiceTermsAgreeFlg)) {

      return (
        <>
          <BffApiResultHandler />
          <TermsOfService title="サービス利用約款　同意" />
        </>
      )
    }
  } else {
    // （ログイン直後と画面リロード時）以外は、isPrimeAuthに値が入るため、以下を判定する
    // 利用可能フラグが利用不可の場合、403画面を描画します。
    if (isPrimeAuth && "0" === loginUserInfo.primeServiceAvailableFlg) {
      history.push(CONSTANTS.PATH_PRIME_PERMISSION_ERROR);
      return <></>;
    }
    
    // プライム契約をしていない場合はエラー画面遷移
    if (isPrimeAuth && loginUserInfo.contractPrimeService !== CONSTANTS.CONTRACT_PRIME_SERVICE.CONTRACT) {
      history.push(CONSTANTS.PATH_PRIME_NO_CONTRACT_ERROR);
      return <></>;
    }

    // 利用対象未設定の場合はエラー
    if (!isPrimeAuth && "0" === loginUserInfo.partnerAvailableFlg) {
      history.push(CONSTANTS.PATH_PARTNER_NOT_SET_USER_ERROR);
      return <></>;
    }

    // （元請・協力）約款に同意していない場合
    if ((isPrimeAuth && "0" === loginUserInfo.primeServiceTermsAgreeFlg) ||
        (!isPrimeAuth && "0" === loginUserInfo.partnerServiceTermsAgreeFlg)) {

      return (
        <>
          <BffApiResultHandler />
          <TermsOfService title="サービス利用約款　同意" />
        </>
      )
    }
  }

  if (isAllow(targetPath, loginUserInfo)) {

    // TOP-URLが指定された場合、指定パスへ遷移
    if ("/top" === props.path && "string" === typeof targetPath) {
      history.push(targetPath);
    }

    // APIResultを初期化します。
    dispatch(initApiResult());
    // DatePickerステートを初期化します。
    dispatch(initDateString());
    // MonthPickerステートを初期化します。
    dispatch(initMonthString());

    return (
      <>
        <BffApiResultHandler />
        <Route {...props} />
      </>
    )
  }


  // 契約や権限により表示できない場合のエラー表示
  if (isPrime) {
    if ("0" === loginUserInfo.authorityInfo.primeAttendanceApprovalRoleAuth
                && "0" === loginUserInfo.authorityInfo.primeAttendanceReffenceRoleAuth
                && "0" === loginUserInfo.authorityInfo.primeAvailableAuth) {
      history.push(CONSTANTS.PATH_PRIME_PERMISSION_ERROR);
      return <></>;
    }
  } else {
    if ("0" === loginUserInfo.authorityInfo.partnerAvailableAuth) {
      history.push(CONSTANTS.PATH_PARTNER_PERMISSION_ERROR);
      return <></>;
    }
  }

  // 上記の処理で判断できなかった場合、403画面を描画します。
  if (loginUserInfo.primeServiceAvailableFlg === "1") {
    history.push(CONSTANTS.PATH_PRIME_PERMISSION_ERROR);
    return <></>;
  } else {
    history.push(CONSTANTS.PATH_PARTNER_PERMISSION_ERROR);
    return <></>;
  }

  // returnに入ることはないが、仕様上記述する
  return <SystemError />
}
